module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-1-0e978f0d56d4e7c40a3f48d36a029d9e.jpg";